const filters = [
  {
    groupName: 'Type of Retaliation',
    options: [
      'Surveillance',
      'Raids in Sanctuary Cities',
      'Immigration Detention/Placed in Removal Proceedings',
      'Detention Center Retaliation',
      'Criminal Prosecution',
      'Deportation',
      'Excessive Fines',
    ],
  },
  {
    groupName: 'Agency',
    options: [
      'Private Contractor',
      'DHS',
      'ICE',
      'CBP',
      'Foreign Authorities',
      'US Fish and Wildlife Services',
      'Local Police/FBI',
      'State DMV',
      'USCIS',
    ],
  },
];

export default filters;
